export default __webpack_public_path__ + "static/media/jsw.5dbd3eb6.png";